<div class="form-component-view">
  <div class="location-card">
    <div class="card-header">
      <div class="location-title">
        <h2 class="location-name">Yard Spot</h2>
      </div>
    </div>
    <div class="objects-section">

      <div class="from-group">
        <label class="form-label">Yard Spot</label>
        <select class="form-input" [disabled]="openYards().length === 0" (change)="onSelectChange($event)">
          <option [value]="null"></option>
          <option *ngFor="let yard of openYards(); let i = index;" [value]="i">{{
            yard.location
            }}</option>
        </select>
      </div>
      <button mat-raised-button matTooltip="Assign move" color="primary"
        [disabled]="!canSubmit()" (click)="reserveSpot()">
        <mat-icon>done</mat-icon>
      </button>

    </div>
  </div>
</div>